import {api} from "api";
import {ChartsModel} from "interfaces";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {thunkBadRequest} from "global/thunk-error";

export const get = createAsyncThunk(
  "home/get-charts",
  async (_, {dispatch, rejectWithValue}) => {
    try {
      return (await api.Get<ChartsModel>("/charts/home"))["data"];
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    }
  }
);
